import { render, staticRenderFns } from "./AppScreenshots.vue?vue&type=template&id=1be5570c"
import script from "./AppScreenshots.vue?vue&type=script&lang=js"
export * from "./AppScreenshots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports